module.exports = __webpack_public_path__ + "static/media/Bank transfer.5cc76f19.svg";